import {
  CodeEditor,
  CodeEditorProps,
} from '@antimatterhq/ui/components/codeEditor';

export type FormCodeEditorProps = {
  name: string;
  value?: string;
  placeholder?: string;
  onChange?: React.FormEventHandler<HTMLSpanElement>;
  onBlur?: React.FocusEventHandler<HTMLSpanElement>;
  hideControls?: boolean;
  disabled?: boolean;
} & Omit<
  CodeEditorProps,
  'code' | 'onValueChange' | 'placeHolder' | 'readOnly'
>;

export const FormCodeEditor = ({
  name,
  onChange,
  value,
  placeholder,
  disabled,
  ...props
}: FormCodeEditorProps) => {
  return (
    <CodeEditor
      {...props}
      code={value || ''}
      placeHolder={placeholder}
      data-testid={`form-code-editor-${name}`}
      name={name}
      readOnly={disabled}
      onChange={(newValue) => {
        onChange?.({
          target: {
            name,
            value: newValue,
          },
        } as unknown as React.ChangeEvent<HTMLInputElement>);
      }}
    />
  );
};
